module.exports = __webpack_public_path__ + "img/W-S58.574d5217.jpg";